import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Typography
} from '@mui/material';

const ApprovalModal = ({ open, onClose, onSubmit, action = 'approve' }) => {
    const [notes, setNotes] = useState('');

    const handleSubmit = () => {
        onSubmit(notes);   // send notes to parent
        // setNotes('');      // clear after submit
    };

    const handleClose = () => {
        setNotes('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 600 }}>
                Add {action} Notes
            </DialogTitle>

            <DialogContent dividers>
                <Typography sx={{ fontSize: '14px', mb: 2 }}>
                    Please enter notes before you {action} this application.
                </Typography>

                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    minRows={4}
                    label="Notes"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                />
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
                <Button onClick={handleClose} variant="outlined">
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    disabled={!notes.trim()}
                    onClick={handleSubmit}
                >
                    Submit & {action}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ApprovalModal;
